<template>
    <v-tooltip v-if="scoreComponentChanged" color="yellow darken-4" top>
        <template #activator="{ on }">
            <span v-bind="$attrs" :class="changedClasses" v-on="on">
                <slot>{{ routine.formatted(component) }}</slot>
            </span>
        </template>
        <span class="font-weight-bold">
            <slot name="tooltip">
                {{ routine.score_changes[0].old[component] }} ->
                {{ routine.score_changes[0].attributes[component] }}
            </slot>
        </span>
    </v-tooltip>
    <span v-else v-bind="$attrs" :class="changedClasses">
        <slot>{{ routine.formatted(component) }}</slot>
    </span>
</template>

<script>
import TrampolineScore from '@/Models/TrampolineScore.js';
import DoubleMiniScore from '@/Models/DoubleMiniScore.js';
import TumblingScore from '@/Models/TumblingScore.js';
import SynchroScore from '@/Models/SynchroScore.js';

export default {
    name: 'ScoreComponent',

    components: {},

    props: {
        routine: {
            type: [TrampolineScore, DoubleMiniScore, TumblingScore, SynchroScore],
            required: true,
        },

        threshold: {
            type: Number,
            required: false,
            default: 0,
        },

        component: {
            type: String,
            required: false,
            default: '',
        },
    },

    computed: {
        scoreComponentChanged() {
            // If the score was last updated more than 1 hour ago, we don't need to check for changes
            if (this.$moment().subtract(this.threshold, 'minutes').isAfter(this.routine.timestamp('updated_at'))) {
                return false;
            }

            if (!this.routine.score_changed || this.routine.score_changes.length === 0) {
                return false;
            }

            const originalValue = this.routine.score_changes[0].old[this.component];
            const newValue = this.routine.score_changes[0].attributes[this.component];

            return originalValue !== newValue;
        },

        changedClasses() {
            return {
                'yellow--text': this.scoreComponentChanged,
                'text--darken-2': this.scoreComponentChanged && this.$vuetify.theme.dark,
                'text--darken-4': this.scoreComponentChanged && !this.$vuetify.theme.dark,
                'font-weight-bold': this.scoreComponentChanged,
            };
        },
    },
};
</script>
